enum AuthActionEnum {
  CLEAR_TOKENS = 'CLEAR_TOKENS',
  LOAD = 'LOAD_AUTH_STORE',
  RECEIVE_TOKENS = 'RECEIVE_TOKENS',
  CLEAR_REFRESH_TOKEN_HANDLER_TIMEOUT = 'CLEAR_REFRESH_TOKEN_HANDLER_TIMEOUT',
  SET_REFRESH_TOKEN_HANDLER_TIMEOUT = 'SET_REFRESH_TOKEN_HANDLER_TIMEOUT',
}

export default AuthActionEnum;
